import axios from 'axios';
import { baseUrl, httpUrl, TOKEN_EXPIRED_CODE } from '@/utils/constant'
import { setToken, getToken } from '@/utils/auth'
import { isBlob } from '@/utils'
import { Notification } from 'element-ui'
import { getPageNameEncoded } from '@/utils/page-cache'
import store from '@/store'
import router from '@/router'

function logout() {
  Notification.warning({
    message: '当前会话已过期，请重新登录',
    duration: 3000,
    onClose: () => {
      store.dispatch('user/logout').then(() => {
        window.location.replace(`${httpUrl}#/login`)
      });
    }
  });
}

function getInitConfig () {
  const config = {
    baseURL: baseUrl,
    timeout: 0,
    headers: {
      Authorization: getToken(),
      'Content-Type': 'application/json;charset=utf-8'
    }
  };
  return config;
}

const axiosInstance = axios.create(getInitConfig());

axiosInstance.interceptors.request.use(
  config => {
    config.headers.Referer2 = location.href;
    config.headers.menu = getPageNameEncoded(router.currentRoute.path);
    config.headers.Authorization = getToken();
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    const accessToken = response.headers['access_token']
    if (accessToken) {
      // console.log('setToken', accessToken);
      setToken(accessToken);
    }

    const { data } = response;
    if (isBlob(data)) {
      return response;
    }

    if (!data || +data.code !== 200) {
      const errorMsg = data.message || '异常的响应数据';
      Notification.error({
        message: errorMsg
      })
      return Promise.reject(errorMsg);
    }

    return data;
  },
  error => {
    let errorInfo = error.response
    let accessToken = '';
    let code = '';

    if (errorInfo) {
      accessToken = errorInfo.headers['access_token']
      code = errorInfo.data && errorInfo.data.code;
    }

    // 错误响应有token时，更新token
    if (accessToken) {
      // console.log('setToken-in-error', accessToken);
      setToken(accessToken);
    }

    if (!errorInfo) {
      errorInfo = {
        data: {
          message: error && error.message || '未知错误'
        }
      }
    }

    // token过期
    if ([10001, 10002].includes(+code)) {
      logout();
      return Promise.reject(error)
    }

    // 全局错误通知
    Notification.error({
      message: !errorInfo.data.message ? error.message : errorInfo.data.message
    })
    return Promise.reject(error)
  }
);

export default axiosInstance;